import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Grid } from '@material-ui/core';

import { Block, Heading } from '@klp/design';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { Loader } from '@klp/design/Loader';
import { Main } from '@klp/layout';

import { ReportAccess } from '../config';
import { useCurrentUser } from '@klp/auth';
import type { MUIDataTableColumn, MUIDataTableOptions } from 'mui-datatables';
import MUIDataTable from 'mui-datatables';
import { reportRtkApi } from '../services/rtkApi';

export const Reports = () => {
    const { t } = useTranslation();
    const { currentUser } = useCurrentUser();

    const { data: reports, isLoading: reportsLoading } =
        reportRtkApi.useGetReportsQuery();

    const renderReportPreview = (value: string) => (
        <Block>
            <Button
                href={value}
                variant="outlined"
                startIcon={
                    <Illustration
                        icon={IconName.SEARCH}
                        klpPalette="primary"
                        klpColor="main"
                    />
                }
                target="_blank"
            >
                {t('report.open')}
            </Button>
        </Block>
    );

    const renderTranslatedReportName = (value: string) =>
        t(`report.name.${value}`);

    const tableColumns: Array<MUIDataTableColumn> = [
        {
            name: 'name',
            label: t('report.report'),
            options: {
                customBodyRender: renderTranslatedReportName,
            },
        },
        {
            name: 'url',
            label: t('report.open'),
            options: {
                customBodyRender: renderReportPreview,
            },
        },
    ];

    const tableOptions: MUIDataTableOptions = {
        search: false,
        download: false,
        print: false,
        viewColumns: false,
        filter: false,
        sort: false,
        selectableRowsHideCheckboxes: true,
        selectableRowsHeader: false,
        selectableRows: 'none',
        textLabels: {
            pagination: {
                next: t('tables.pagination.next'),
                previous: t('tables.pagination.previous'),
                rowsPerPage: t('tables.pagination.rowsPerPage'),
                displayRows: t('tables.pagination.displayRows'),
            },
        },
    };

    if (!ReportAccess(currentUser)) return null;

    return (
        <Loader isLoading={reportsLoading}>
            <Main>
                <Main.Breadcrumbs>
                    <Main.Crumb id="reports" label={t('breadcrumbs.reports')} />
                </Main.Breadcrumbs>
                <Heading
                    klpHeadingLevel="THREE"
                    translation="report.title"
                    marginBottom="compact"
                />
                <Grid container={true}>
                    <Grid item={true} xs={12} sm={8} md={6}>
                        <MUIDataTable
                            title=""
                            data={reports ?? []}
                            columns={tableColumns}
                            options={tableOptions}
                        />
                    </Grid>
                </Grid>
            </Main>
        </Loader>
    );
};
